export * from './sidebar.directive';



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/directives/sidebar/index.ts